import { combineSlices } from "@reduxjs/toolkit";
import { caseManagementSlice } from "../caseManagement/store/slice";
import { caseViewerSlice } from "../caseViewer/store/slice";
import { caseExportsSlice } from "../caseExports/store/slice";

// exports
export const casesReducer = combineSlices(
    caseManagementSlice,
    caseViewerSlice,
    caseExportsSlice,
);
